import TwitterIcon from '@/components/shared/icons/twitter-icon';
import { Box, useTheme } from '@mui/material';

const ShareArticle = ({ articleUrl, title, hashtags = [] }) => {
    const theme = useTheme();
    if (!articleUrl) return null;

    const hashtagList = [...hashtags, 'analiticaFantasy', 'fantasyLaLiga', 'fantasyFutbol', 'laligafantasy'];
    const encodedUrl = encodeURIComponent(articleUrl);
    const encodedTitle = encodeURIComponent(title);
    const encodedHashtags = encodeURIComponent(hashtagList.join(','));

    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}&hashtags=${encodedHashtags}`;

    return (
        <Box className="share-line">
            <a href={twitterUrl} target="_blank" rel="noopener noreferrer" aria-label="Compartir en Twitter">
                <TwitterIcon color={theme.palette.text.primary} iconWidth={24} iconHeight={24} />
            </a>
        </Box>
    );
};

export default ShareArticle;
